import React, { Component } from "react";

import { Form, TextArea } from "informed";
import { AppLinks } from "../../constants/app-links";
import { Link } from "react-router-dom";

import { sendContactInfo } from "../../api/messages-api";

import MaskValidateUtil from "../common/util/MaskValidateUtil";
import ErrorView from "../common/error-view/ErrorView";
import Loader from "../common/loader/Loader";
import EditText from "../common/form-fields/edit-text/EditText";
import DropDownSelect from "../common/form-fields/drop-down/DropDownSelect";

import { UncontrolledCollapse } from "reactstrap";

import "../contact/contact.view.component.css";

export const contactInformation = () => {
  return (
    <React.Fragment>
      <h4 className="d-flex align-items-center margin-bottom">
        Contact us by phone, fax or mail:
      </h4>
      <div className="margin-left-right margin-bottom">
        <div className="mt-3">
          <img className="contact-image-item" 
            alt = "phonenumber" 
            src="/assets/images/icon_phonenumber.svg" 
          />
          <div className="text-container">
            <strong> Phone </strong> 
            <div> 855-898-8991 </div>
            <div> Monday-Friday from 7:00am to 5:00pm PT </div>
            <div> Saturday from 8:00am to 5:00pm PT </div>
            <div>Closed Sunday</div>
          </div>
        </div>
        <div className="mt-4">
          <img className="contact-image-item" 
            alt = "phonenumber" 
            src="/assets/images/icon_fax.svg" 
          />
          <div className="text-container">
            <strong> FAX </strong>
            <p> 888 - 228 - 4129 </p>
          </div>
        </div>
        <div className="mt-4">
          <img className="contact-image-item" 
            alt = "phonenumber" 
            src="/assets/images/icon_mail.svg"
          />
          <div className="text-container">
            <strong> Mail </strong>
            <p> Healthy Paws</p>
            <p> P.O. Box 1156 </p>
            <p className="margin-bottom"> Portland, ME 04104 </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export class ContactForm extends Component {
  constructor() {
    super();
    this.errorText = "";
    this.state = {
      sendingToServer: false,
      serverError: false,
    }
  }

  sendContactInfo = values => {

    const salesforceMessage = `${values.message}\nA no-loss letter is required.`;

    this.setState({
      sendingToServer: true
    });

    var contactInfo = {
      contact_email: values.email,
      full_name: values.name,
      message: salesforceMessage,
      phone_number: values.primaryPhoneNumber.replace(/\D/g, ""),
      return_url: "",
      Subject: "Reinstate Payment Cancellation", 
      reason_code: "PaymentCancellationReinstate"
    };

    var index = values.name.indexOf(" ");

    if (index > 0) {
      contactInfo.first_name = values.name.substr(0, index);
      contactInfo.last_name = values.name.substr(index + 1);
    } else {
      contactInfo.first_name = values.name;
      contactInfo.last_name = "";
    }

    sendContactInfo(contactInfo)
      .then(response => {
        this.setState({
          sendingToServer: false
        });
        console.log(JSON.stringify(response));
        this.props.setShowContactThankYouPage();
        window.scrollTo(0, 0);
      })
      .catch(error => {
        this.errorText = error.errorMessage ? error.errorMessage : "Unable to send information. Please try again later or call us at 855-898-8991.";
        this.setState({
          sendingToServer: false,
          serverError: true
        });
        if (this.props.showDropDown) window.scrollTo(0, 0);
      });
  };

  render() {
    return (
      <div className="contact-form-container position-relative">
        {this.state.serverError && <ErrorView>{this.errorText}</ErrorView>}
        <Form
          className="contact-form margin-left-right"
          getApi={api => {
            this.props.setContactFormFieldAPI(api);
          }}
          onSubmit={values => {
            this.sendContactInfo(values);
          }}
        >
          {({ formState }) => (
            <React.Fragment>
              <EditText
                required
                className="input-container margin-bottom"
                id="name"
                field="name"
                type="text"
                title="Name"
                floatingTitle={true}
              />
              <EditText
                required
                email
                className="input-container margin-bottom"
                id="email_address"
                field="email"
                type="text"
                title="Email Address"
                validate={MaskValidateUtil.validateEmail}
                validateOnBlur
                validateOnChange
                floatingTitle={true}
              />
              <EditText
                required
                className="phone-input-container margin-bottom"
                id="primary-phone-number"
                field="primaryPhoneNumber"
                type="text"
                title="Primary Phone #"
                floatingTitle={true}
                mask={MaskValidateUtil.phoneNumberMask}
              />
             {this.props.showDropDown && (
                  <React.Fragment>
                    <h4>I have a question regarding...</h4>
                    <TextArea
                      field="reason"
                      className="address-input-container margin-bottom"
                      id="reason_textarea"
                      rows="3"
                      required
                      initialValue="Reinstate Customer Center Request"
                      style={{ resize: "none" }}
                    />
                  </React.Fragment>
                )}
              <TextArea
                  placeholder="Message"
                  required
                  rows="6"
                  className="input-container text-area-input margin-bottom"
                  id="message"
                  field="message"
                  initialValue={`This customer has requested their account to be reinstated via Marketing Campaign link.`}
                />

                <button className="input-container button-primary" type="submit">
                  Send
                </button>
            </React.Fragment>
          )}
        </Form>
        {(this.state.sendingToServer || this.props.fetching) && <Loader position="absolute" />}
        <div className="contact-info-section">
        {contactInformation()}
      </div>
      </div>
    );
  }
}
